/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, OnInit} from '@angular/core';

export function progressBarCalculator(delPercentage: number): number[] {
  const value = delPercentage || 0;
  return [Math.min(value, 100)];
}

@Component({
  standalone: false,
  selector: 'adn-percentage-bar',
  template: `
    <div class="percentageBarLine" *ngFor="let loop of loopNums; let i = index">
      <span class="progress-bar percentageBarFill" role="progressbar" [style.width.%]="loop || 0" [style.background-color]="color">&nbsp;</span>
      <span class="percentageBarLabel" *ngIf="i === 0">
        <span *ngIf="rawDeliveryPercentage > displayPercentage">&gt;</span>{{ displayPercentage / 100 | percentage:2:true }}
      </span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .percentageBarLine {
      position: relative;
      height: 18px;
      line-height: 18px;
      text-align: left;
    }

    .percentageBarFill {
      position: absolute;
      top: 1px;
      bottom: 1px;
      left: 0;
      display: block;
      height: auto;
      background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.22) 0%, rgba(40, 39, 45, 0.08) 100%);
    }

    .percentageBarLabel {
      position: absolute;
      z-index: 1;
      top: 0;
      bottom: 0;
      left: 4px;
      display: flex;
      align-items: center;
      color: inherit;
      line-height: 1;
    }
  `]
})
export class PercentageBarComponent implements OnInit, OnChanges {
  /** Angular list pages bind [deliveryPercentage]. */
  @Input() deliveryPercentage: number;
  @Input() maximum: number;
  @Input() color = '#daebf8';

  displayPercentage = 0;
  rawDeliveryPercentage = 0;
  loopNums: number[] = [];

  ngOnInit(): void {
    this.updateDisplay();
  }

  ngOnChanges(): void {
    this.updateDisplay();
  }

  private updateDisplay(): void {
    const maximum = this.maximum || 1000;
    const deliveryPercentage = this.deliveryPercentage ?? 0;
    this.rawDeliveryPercentage = deliveryPercentage;
    this.displayPercentage = Math.min(maximum, deliveryPercentage);
    this.loopNums = progressBarCalculator(this.displayPercentage);
  }
}
